import Vue from 'vue'
import VeeValidate, { Validator } from 'vee-validate'

const dictionary = {
  en: {
    messages: {
      // <input type="text" v-model="phoneNumber" name="phone" v-validate="'required|phone'">
      // 不满足required条件时，显示的提示对应下面的设置
      // required: (field) => `${field} is necessary!`,
      required: () => '必須入力項目が未入力です。',
      numeric: () => '数字以外入力できません。',
      max: (field) => `${field}桁以下入力してください。`
    },
    attributes: {
      // <input type="text" v-model="phoneNumber" name="phone" v-validate="'required|phone'">
      // 上述messages提示信息中field显示的内容在此设置，对应标签的name属性
      // phone: 'Phone Number',
      // postCode: '郵便番号'
      // phone: '電話番号',
      // carryNumber: '携帯番号',
      // fax: 'FAX'
      address: '50'
    }
  }
}

// 引用上述设置
Validator.localize(dictionary)

// // 自定义验证规则,取名为phone, 通过该方式使用v-validate="'required|phone'"
// Validator.extend('phone', {
//   // 验证规则，符合规则通过，否则不通过 (规则为美国电话号码)
//   validate: (value, ref) => {
//     return /^(\d3|^\d{3}[.-]?)?\d{3}[.-]?\d{4}$/.test(value)
//   },
//   // 提示信息，不符合规则提示语
//   // <span v-show="errors.has('phone')" class="error-message"> {{ errors.first('phone') }} </span>
//   getMessage: (field) => 'The ' + field + ' is invalid.'
// })

// 自定义校验：郵便番号,電話番号,携帯番号,FAX
Validator.extend('specialNumber', {
  getMessage: field => '数字以外入力できません。',
  validate: value => /^([0-9]|-)*$/.test(value)
})
// 自定义绘文字不能入力
Validator.extend('paintWordNo', {
  getMessage: field => '不正な入力です。',
  validate: value => !/\ud83c[\udc00-\udccf]|\ud83c[\udd70-\ude5f]|\ud83c[\udf00-\udfff]|\ud83d[\udc00-\ude4f]|\ud83d[\ude80-\udeff]|\ud83e[\udd10-\uddcf]|\ud7c9[\ude00-\udeff]|\u0023\u20e3|[\u0030-\u0039]\u20e3|\u00a9|\u00ae|\u2002|\u2003|\u2005|\u203c|\u2049|\u2122|\u2139|[\u2194-\u2199]|[\u21a9-\u21aa]|[\u231a-\u231b]|\u2328|\u23cf|[\u23e9-\u23fa]|\u24c2|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|[\u2600-\u27ff]|[\u2934-\u2935]|[\u2b05-\u2b1c]|[\u2b50-\u2B55]|[\u3030-\u303f]|[\u3290-\u329f]/g.test(value)
})

// 自定义校验：パスワード
Validator.extend('passwordValidator', {
  getMessage: field => '8ビットの英字と数字以外入力できません。',
  validate: value => /^([0-9]|[a-z]|[A-Z]){8}$/.test(value)
})

// 配置
const config = {
  errorBagName: 'errors', // change if property conflicts.
  fieldsBagName: 'fields',
  delay: 0,
  strict: true,
  enableAutoClasses: false,
  classNames: {
    touched: 'touched', // the control has been blurred
    untouched: 'untouched', // the control hasn't been blurred
    valid: 'valid', // model is valid
    invalid: 'invalid', // model is invalid
    pristine: 'pristine', // control has not been interacted with
    dirty: 'dirty' // control has been interacted with
  },
  events: 'input|blur',
  inject: true
}

// 事件触发规则，在输入框中输入后点击事件触发验证，默认为实时验证
Vue.use(VeeValidate, config)



// WEBPACK FOOTER //
// ./src/utils/Validate.js